import { apiFetch } from './apiFetch';
import type {
  CreateDepositRequest,
  DepositDetail,
  DepositSummary,
  ListDepositsQuery,
} from '@deposits/shared';

export async function fetchDepositsList(
  q: ListDepositsQuery,
): Promise<DepositSummary[]> {
  const params = new URLSearchParams({
    location_id: String(q.location_id),
    from: q.from,
    to: q.to,
    status: q.status,
  });
  if (q.search) params.set('search', q.search);
  if (q.project_id != null) params.set('project_id', String(q.project_id));
  return apiFetch<DepositSummary[]>(`/deposits?${params.toString()}`);
}

export async function fetchDepositDetail(id: number): Promise<DepositDetail> {
  return apiFetch<DepositDetail>(`/deposits/${id}`);
}

export interface CreateDepositResponse {
  id: number;
  deposit_number: number;
  pdf_status: 'pending' | 'ready' | 'failed';
  /** Signed S3 URL — open in a new tab. Null when render failed. */
  pdf_url: string | null;
}

export async function createDeposit(
  body: CreateDepositRequest,
): Promise<CreateDepositResponse> {
  return apiFetch<CreateDepositResponse>('/deposits', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function cancelDeposit(id: number, reason?: string | null): Promise<void> {
  await apiFetch<void>(`/deposits/${id}/cancel`, {
    method: 'POST',
    body: JSON.stringify(reason ? { reason } : {}),
  });
}
